export const PICS = [
        { id: "01", url: './images/Colour01.png', selected: false },
        { id: "02", url: './images/Colour02.png', selected: false },
        { id: "04", url: './images/Colour04.png', selected: false },
        { id: "05", url: './images/Colour05.png', selected: false },
        { id: "06", url: './images/Colour06.png', selected: false },
        { id: "07", url: './images/Colour07.png', selected: false },
        { id: "08", url: './images/Colour08.png', selected: false },
        { id: "10", url: './images/Colour10.png', selected: false },
        { id: "11", url: './images/Colour11.png', selected: false },
        { id: "12", url: './images/Colour12.png', selected: false },
        { id: "13", url: './images/Colour13.png', selected: false },
        { id: "14", url: './images/Colour14.png', selected: false },
        { id: "15", url: './images/Colour15.png', selected: false },
        { id: "17", url: './images/Colour17.png', selected: false },
        { id: "18", url: './images/Colour18.png', selected: false },    
        { id: "19", url: './images/Colour19.png', selected: false },
        { id: "20", url: './images/Colour20.png', selected: false },
        { id: "21", url: './images/Colour21.png', selected: false },
        { id: "22", url: './images/Colour22.png', selected: false },
        { id: "23", url: './images/Colour23.png', selected: false },
        { id: "24", url: './images/Colour24.png', selected: false },
        { id: "25", url: './images/Colour25.png', selected: false },
        { id: "26", url: './images/Colour26.png', selected: false },
        { id: "27", url: './images/Colour27.png', selected: false },
        { id: "28", url: './images/Colour28.png', selected: false },
        { id: "29", url: './images/Colour29.png', selected: false },
        { id: "30", url: './images/Colour30.png', selected: false },
        { id: "32", url: './images/Colour32.png', selected: false },
        { id: "33", url: './images/Colour33.png', selected: false },
        { id: "39", url: './images/Colour39.png', selected: false },
        { id: "40", url: './images/Colour40.png', selected: false },
        { id: "41", url: './images/Colour41.png', selected: false },
        { id: "42", url: './images/Colour42.png', selected: false },
        { id: "44", url: './images/Colour44.png', selected: false },
        { id: "46", url: './images/Colour46.png', selected: false },
        { id: "47", url: './images/Colour47.png', selected: false },
        { id: "48", url: './images/Colour48.png', selected: false },
        { id: "49", url: './images/Colour49.png', selected: false },
        { id: "50", url: './images/Colour50.png', selected: false },
    ]
